import React, { useContext } from 'react';

import './index.scss';
import LodingImage from 'assets/loading.svg';
import SpHeader from 'components/organisms/SpHeader';
import SpTitle from 'components/organisms/SpTitle';
import SpFooter from 'components/organisms/SpFooter';
import SpButtonArea from 'components/molecules/SpButtonArea';

import { PAGE_MAP, FATAL_ERROR_MESSAGES } from 'utils/constant';
import { useAnalytics } from 'utils';

import AppContext from 'fluxes/context';

const SpBasicTemplate = ({
  path,
  children,
  onClickMainButton,
  valid,
  isApiError,
  showLoading,
  lpMode,
}) => {
  const { state } = useContext(AppContext);
  const { isModify } = state;
  const { step, subStep, title, subTitle, prevUrl, nextUrl, buttonType } = PAGE_MAP[path];
  
  useAnalytics(lpMode); // Web計測

  return (
    <div className="SpBasicTemplate">
      <SpHeader step={step} lpMode={lpMode} />
      <div className="title">
        <SpTitle
          step={step}
          subStep={subStep}
          title={title}
          subTitle={subTitle}
        />
      </div>
      <div className="children">
        {children}
      </div>
      <div className="button-area">
        <SpButtonArea
          onClickMainButton={onClickMainButton}
          prevUrl={prevUrl}
          nextUrl={nextUrl}
          isModify={isModify}
          buttonType={buttonType}
          valid={valid}
          lpMode={lpMode}
        />
      </div>
      {!lpMode && (
        <div className="footer">
          <SpFooter />
        </div>
      )}
      {lpMode && ( <>&nbsp;</> )}
      {/* ローディング */}
      {showLoading && (
        <div className="loading-modal-wrapper">
          <div className="loading-modal-wrapper-background">
            <img className="loading-image" src={LodingImage} alt="loading" />
          </div>
        </div>
      )}
      {/* APIエラーモーダル */}
      {isApiError && (
        <div className="api-error-modal-wrapper">
          <div className="api-error-modal-wrapper-background">
            <div className="api-error-modal">
              {FATAL_ERROR_MESSAGES.map(message => <div key={message}>{message}</div>)}
              <div className="api-error-top-link"><a href="/jobma/">Jobマ!トップへ戻る</a></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpBasicTemplate;